export default __webpack_public_path__ + "static/media/jockUi@2x.e31868de.png";